(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'react-emotion', '../../styles/colors', './Spinners.css'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('react-emotion'), require('../../styles/colors'), require('./Spinners.css'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.reactEmotion, global.colors, global.Spinners);
    global.Spinners = mod.exports;
  }
})(this, function (exports, _react, _reactEmotion, _colors, _Spinners) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Spinner = Spinner;
  exports.SpinnerLarge = SpinnerLarge;

  var _react2 = _interopRequireDefault(_react);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function Spinner(props) {
    var className = props.className,
        _props$color = props.color,
        color = _props$color === undefined ? 'peach' : _props$color;

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _reactEmotion.cx)(_Spinners.styles.svg, (0, _reactEmotion.css)({ stroke: _colors2.default[color] ? _colors2.default[color] : color }), className),
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '25 25 50 50'
      },
      _react2.default.createElement('circle', { className: (0, _reactEmotion.cx)(_Spinners.styles.circle, 'path'), cx: '50', cy: '50', r: '20' })
    );
  }

  function SpinnerLarge(props) {
    var className = props.className,
        _props$color2 = props.color,
        color = _props$color2 === undefined ? 'peach' : _props$color2;

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _reactEmotion.cx)(_Spinners.styles.svg, (0, _reactEmotion.css)({ stroke: _colors2.default[color] ? _colors2.default[color] : color }), _Spinners.styles.large, className),
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '25 25 50 50'
      },
      _react2.default.createElement('circle', { className: (0, _reactEmotion.cx)(_Spinners.styles.circle, 'path'), cx: '50', cy: '50', r: '20' })
    );
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/LoadingIndicators/Spinners.js
// module id = 1948
// module chunks = 1